import DashboardLoading from 'frontend/components/dashboard-loading';
<template><DashboardLoading /></template>
